<template>
  <el-dialog
    title="回收站"
    :visible.sync="isShow"
    width="900px"
    :close-on-click-modal="false"
    :append-to-body="true"
    @open="handleOpen"
  >
    <div style="margin-bottom:12px;display:flex;gap:8px;align-items:center;">
      <el-input
        v-model.trim="filterName"
        placeholder="请输入属性名称"
        size="small"
        clearable
        style="width:220px;"
        @clear="handleSearch"
        @keyup.enter.native="handleSearch"
      >
        <i slot="suffix" class="el-icon-search" style="cursor:pointer;line-height:32px;margin-right:4px;" @click="handleSearch"></i>
      </el-input>
    </div>

    <el-table
      ref="table"
      :data="list"
      border
      size="small"
      v-loading="loading"
    >
      <el-table-column label="属性名" prop="name" min-width="150" show-overflow-tooltip></el-table-column>
      <el-table-column label="属性值类型" prop="valueTypeDesc" min-width="120" show-overflow-tooltip></el-table-column>
      <el-table-column label="备注" prop="remark" min-width="150" show-overflow-tooltip></el-table-column>
      <el-table-column label="创建时间" prop="createTime" min-width="150" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.createTime | date-format }}</template>
      </el-table-column>
      <el-table-column label="创建人" prop="createUserName" min-width="120" show-overflow-tooltip></el-table-column>
      <el-table-column label="状态" prop="enableFlagDesc" min-width="100" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="80" fixed="right">
        <template slot-scope="{ row }">
          <span class="table-action" @click="handleRestore(row)">还原</span>
        </template>
      </el-table-column>
    </el-table>

    <div style="margin-top:12px;display:flex;justify-content:flex-end;">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next"
        :total="total"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :page-sizes="[10, 20, 50]"
        @current-change="loadList"
        @size-change="handleSearch"
      ></el-pagination>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="isShow = false">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getDeletedAttributeList, restoreAttribute } from '@/api/PlatformSales/ProductAttributes';

export default {
  name: 'RecycleBin',
  data () {
    return {
      isShow: false,
      loading: false,
      filterName: '',
      attributeCategoryId: null,
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
    };
  },
  methods: {
    initPage (attributeCategoryId) {
      this.attributeCategoryId = attributeCategoryId || null;
      this.isShow = true;
    },
    handleOpen () {
      this.filterName = '';
      this.handleSearch();
      this.$nextTick(() => {
        this.$refs.table && this.$refs.table.doLayout();
      });
    },
    handleSearch () {
      this.currentPage = 1;
      this.loadList();
    },
    loadList () {
      this.loading = true;
      getDeletedAttributeList({
        name: this.filterName || null,
        attributeCategoryId: this.attributeCategoryId || null,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      }).then(({ body }) => {
        this.list = body?.list || [];
        this.total = body?.total || 0;
      }).finally(() => {
        this.loading = false;
      });
    },
    handleRestore (row) {
      this.$confirm(`确认还原属性「${row.name}」吗？`, '还原').then(() => {
        restoreAttribute({ id: row.id }).then(() => {
          this.$message.success('还原成功');
          this.loadList();
          this.$emit('restored');
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ .el-dialog__header {
  padding-top: 0;
  border-bottom: 1px solid #E4E7ED;
  display: flex;
  align-items: center;
  height: 40px;
}

/deep/ .el-dialog__footer {
  border-top: 1px solid #E4E7ED;
}

/deep/ .el-table .table-action {
  cursor: pointer;
  color: #5195EB;
}

/deep/ .el-table .table-action:not(:first-child) {
  margin-left: 10px;
}
</style>
